import type { FieldSalesRepresentativeCompanyAndContact } from '../api';
import { FieldSalesRepresentativeCompanyContactItem } from './FieldSalesRepresentativeCompanyContactItem';

interface FieldSalesRepresentativeCompanyContactListProps {
  representatives: FieldSalesRepresentativeCompanyAndContact[];
}

/**
 * @component FieldSalesRepresentativeCompanyContactList
 * @description Renders the read-only list of field sales representative company/contact assignments.
 *
 * @props
 *   representatives (FieldSalesRepresentativeCompanyAndContact[], required) - Assignments to display.
 *
 * @changelog
 *   2026-07-08 - Initial creation.
 */
export function FieldSalesRepresentativeCompanyContactList({
  representatives,
}: FieldSalesRepresentativeCompanyContactListProps) {
  return (
    // Vertical list of all representative assignments for a customer company.
    <div className="flex flex-col gap-2">
      {representatives.map((representative) => (
        <FieldSalesRepresentativeCompanyContactItem
          key={`${representative.company.id}-${representative.contact.id}`}
          representative={representative}
        />
      ))}
    </div>
  );
}
